export default "__VITE_ASSET__BYq5FVDU__"